<script setup lang="ts">
import CustomModal from "@/components/CustomModal/CustomModal.vue";
import { onMounted, onUnmounted, ref } from "vue";
import CustomButton from "@/components/Button/Button.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const { open } = defineProps({
  open: {
    type: Boolean,
    required: true
  }
});

const emit = defineEmits(['on-close']);

const invitees = ref(['Sarah@howdy.gr', 'test@test.com']);

const friends = [
  {
    name: 'Sarah',
    email: 'Sarah@howdy.com',
  },
  {
    name: 'John',
    email: 'test@test.com',
  },
  {
    name: 'John Doe',
    email: 'john@doe.com',
  }
];

function inviteSelectedAndClose() {
  emit('on-close');
}

function inviteAll() {
  invitees.value = friends.map(friend => friend.email);
}

function inviteFriend(email: string) {
  if (!invitees.value.includes(email)) {
    invitees.value.push(email);
  }
  emit('on-close');
}

const width = ref(window.innerWidth);
function updateWidth() {
  width.value = window.innerWidth;
}
onMounted(() => {
  window.addEventListener('resize', updateWidth);
});

onUnmounted(() => {
  window.removeEventListener('resize', updateWidth);
});
</script>

<template>
  <CustomModal :show="open" @on-close="$emit('on-close')">
    <div :class="width < 768 ? 'flex flex-col h-screen w-screen' : 'flex flex-col h-[642px] w-[460px]'">
      <div class="p-5 bg-gradient-to-l from-gradients-ghostWhite to-gradients-aliceBlue flex flex-col">
        <div class="cursor-pointer self-end" type="default" @click="$emit('on-close')">
          <img src="@/assets/icons/svg/Close_16x16.svg" :alt="t('close')" width="18" />
        </div>
        <div>
          <h1 class="responsive-title-6 font-semibold">{{ t('invite_crew_members') }}</h1>
          <div class="mt-9 flex flex-col mx-6">
            <div class="flex flex-row justify-between items-center">
              <div class="max-w-[270px] flex flex-col gap-1">
                <div v-for="invitee in invitees" :key="invitee"
                  class=" responsive-body-small bg-white w-fit h-8.5 py-1.5 px-2 rounded-4xl">
                  {{ invitee }}
                </div>
              </div>
              <CustomButton type="black" :rounded="true" class="h-8.5" @click="inviteSelectedAndClose">{{ t('invite')
                }}
              </CustomButton>
            </div>
            <div class="mt-3 h-0.5 bg-black w-full" />
          </div>
        </div>
      </div>
      <div :class="width < 768 ? 'flex flex-col h-screen w-screen' : 'flex flex-col h-[642px] w-[460px]'">
        <div class="h-[467px] max-h-[467px] overflow-y-scroll p-11">
          <div class="flex flex-row justify-between items-center mb-4">
            <div class="flex flex-row items-center gap-2">
              <span class=" responsive-body-large font-semibold">{{ t('friends') }}</span>
              <span class="responsive-body-xsmall text-black/40">({{ friends.length }} {{ t('members') }})</span>
            </div>
            <div class="underline cursor-pointer" @click="inviteAll()">
              {{ t('invite_all') }}
            </div>
          </div>
          <div class="flex flex-col gap-4">
            <div v-for="friend in friends" :key="friend.email" class="flex flex-row items-center justify-between">
              <div>
                {{ friend.name }}
              </div>
              <div class="border border-black/40 rounded-11xl px-4 py-1.5 cursor-pointer"
                @click="inviteFriend(friend.email)">
                <img src="/assets/icons/svg/Check_16x16.svg" :alt="t('select')" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </CustomModal>
</template>

<style scoped>
:deep(.modal-content) {
  padding: 0;
}
</style>
